import api from './api';

export const getAffiliates = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await api.get(`/affiliates?${queryParams}`);
  return response.data;
};

export const getAffiliateById = async (id) => {
  const response = await api.get(`/affiliates/${id}`);
  return response.data;
};

export const createAffiliate = async (data) => {
  const response = await api.post('/affiliates', data);
  return response.data;
};

export const updateAffiliate = async (id, data) => {
  const response = await api.put(`/affiliates/${id}`, data);
  return response.data;
};

export const deleteAffiliate = async (id) => {
  const response = await api.delete(`/affiliates/${id}`);
  return response.data;
};

export const getAffiliateStats = async (id) => {
  const response = await api.get(`/affiliates/${id}/stats`);
  return response.data;
};

export const recordAffiliatePayment = async (id, paymentData) => {
  const response = await api.post(`/affiliates/${id}/payments`, paymentData);
  return response.data;
};
